import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const searchClient = async ({ sapCode, name }) => {
  const instance = getAxiosInstance();
  return instance.get(
    `${config.baseUrl}${config.paths.searchClients}?tercero=${sapCode}&name=${name}`
  );
};

export default {
  searchClient
};
